import React, { useState } from "react";
import { useSelector } from "react-redux";
import './ChangePasswordModal.scss';

const selector = state => {
    const { language } = state;
    return {
        t: language.translator
    }
};

const ChangePasswordModal = props => {
    const { closeMethod, confirmMethod, confirmButtonText } = props;
    const { t } = useSelector(selector);
    const [newPassword, setNewPassword] = useState('');

    const closeModal = () => {
        closeMethod();
    };

    return(
        <div
            className='changePasswordModalBlur'
            onClick={e => {
                if(e.target.className === 'changePasswordModalBlur') {
                    closeModal()
                }
            }}
        >
            <div className='changePasswordModalWindow'>
                <form className='changePasswordForm' autoComplete='off'>
                    <div className='changePasswordFormItem'>
                        <label className='changePasswordFormLabel'>
                            {t.gettext('New password')}
                        </label>
                        <input
                            className='changePasswordFormInput'
                            defaultValue=''
                            onInput={e => {
                                setNewPassword(e.target.value);
                            }}
                            type='password'
                        />
                    </div>
                </form>
                <div className='changePasswordModalButtonsHolder'>
                    <button
                      className='changePasswordModalCancelButton'
                      onClick={e => {
                          e.preventDefault();
                          closeModal();
                      }}
                    >
                        {t.gettext('Cancel')}
                    </button>
                    <button
                      className='changePasswordModalConfirmButton'
                      onClick={e => {
                          e.preventDefault();
                          confirmMethod(newPassword);
                      }}
                      disabled={!newPassword}
                    >
                        {confirmButtonText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ChangePasswordModal;
